import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";
import type { GetOrganisationUsersResponse } from "./getOrganisationUsers";

const endpoint = spellbook("/me/organisations/users/{id}").PATCH();

export type PatchOrganisationUserReq = typeof endpoint.types.Req;

export async function patchOrganisationUser(
    id: string,
    req: PatchOrganisationUserReq,
): Promise<GetOrganisationUsersResponse | null> {
    const call = createCall(endpoint, (request) => fetch(withAccountOrNetworkAuthHeaders(request)));

    try {
        return await call({ params: { id }, req });
    } catch {
        // Spellbook handles the toast and auth redirect; keep this direct caller quiet.
        return null;
    }
}
